exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main {\n  padding: 3%; }\n  main small {\n    font-size: 15px; }\n  main .details {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 30px; }\n    main .details img {\n      height: 60px;\n      width: 60px;\n      -o-object-fit: cover;\n         object-fit: cover; }\n    main .details strong {\n      margin-bottom: 10px; }\n    main .details .results-list {\n      width: 70%;\n      border-bottom: 1px solid #ccc; }\n\n.clear {\n  color: #00b1b1;\n  cursor: pointer; }\n\n.clear:hover {\n  color: #007474; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/app/details/details.component.scss
// module id = ../../../../../src/app/details/details.component.scss
// module chunks = main